module.exports = __webpack_public_path__ + "5c114213/img/settings-icon.121d9519.svg";